export const convertBytesToMbsOrKbs = (filesize: number) => {
  if (filesize >= 1_048_576) {
    return `${filesize / 1_048_576} MB`;
  }
  if (filesize >= 1024) {
    return `${filesize / 1024} KB`;
  }
  return `${filesize} B`;
};
